'use client';

import React from 'react';
import { FormProvider } from 'react-hook-form';
import { Alert, Box, Typography } from '@mui/material';
import { Loading } from '@/components/loader/Loading';
import { useLogic } from './logic';
import { parseHospitalListings } from '@/helpers/parseHospitalListings';
import { api_portalOfficeHospitalListing_medicalSubject } from '@/init/swagger';
import { HospitalSearchBox } from '@/features/station/word/HospitalSearchBox';
import { HospitalListingItem } from '@/features/hospital/HospitalSearchResults/HospitalListingItem';
import { EmptyBox } from '@/components/EmptyBox';

type Props = {
  hospitalMedicalSubjects: api_portalOfficeHospitalListing_medicalSubject[];
};

export function PublicSearchWordHospitalsPage({
  hospitalMedicalSubjects,
}: Props) {
  const { method, handleSearch, displayListings, errorMessage, isLoading } =
    useLogic();

  return (
    <Box sx={{ px: 15, py: 2, '@media (max-width: 600px)': { px: 2 } }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FormProvider {...method}>
          <form onSubmit={method.handleSubmit(handleSearch)}>
            <HospitalSearchBox isPublicSearch={true} />
          </form>
        </FormProvider>

        {!!errorMessage && (
          <Alert severity="error" sx={{ whitespace: 'pre-line' }}>
            {errorMessage}
          </Alert>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          pt: 3,
          pb: 4,
        }}
      >
        <Typography variant="JP/Heading/lg/Bold/Tight">
          検索された医療機関
        </Typography>
      </Box>

      <>
        {displayListings.length === 0 ? (
          <Box sx={{ mx: 2 }}>
            <EmptyBox
              mainMessage="ご指定の条件に該当する医療機関が見つかりませんでした"
              subMessage="検索条件を変更して、再度検索してください。"
            />
          </Box>
        ) : (
          <>
            {parseHospitalListings(displayListings).map((listing) => (
              <Box key={listing.id} mb={2}>
                <HospitalListingItem
                  hospitalMedicalSubjects={hospitalMedicalSubjects}
                  listingInfo={listing}
                  isPublicSearch={true}
                  localFavorites={[]}
                  setLocalFavorites={() => {}}
                />
              </Box>
            ))}
          </>
        )}
      </>
      <Loading isLoading={isLoading} />
    </Box>
  );
}
